var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.798 5.14326L11.3078 4.63348C12.1525 3.78884 13.5219 3.78884 14.3665 4.63348C15.2112 5.47812 15.2112 6.84754 14.3665 7.69218L13.8567 8.20196M10.798 5.14326C10.798 5.14326 10.8618 6.22655 11.8176 7.1824C12.7734 8.13824 13.8567 8.20196 13.8567 8.20196M10.798 5.14326L6.11135 9.82994C5.79391 10.1474 5.63519 10.3061 5.49869 10.4811C5.33767 10.6876 5.19962 10.9109 5.08699 11.1473C4.9915 11.3476 4.92052 11.5606 4.77856 11.9865L4.17699 13.7911M13.8567 8.20196L9.17006 12.8886C8.85262 13.2061 8.6939 13.3648 8.51889 13.5013C8.31245 13.6623 8.08908 13.8004 7.85274 13.913C7.65238 14.0085 7.43944 14.0795 7.01355 14.2214L5.20886 14.823M5.20886 14.823L4.76771 14.9701C4.55813 15.0399 4.32706 14.9854 4.17085 14.8292C4.01463 14.6729 3.96009 14.4419 4.02995 14.2323L4.17699 13.7911M5.20886 14.823L4.17699 13.7911",
    stroke: "#808086"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.371f8faa6b756c3e1eae29975a8a00d1.svg";
export { ForwardRef as ReactComponent };